import { Route } from "react-router-dom"
import { pagesUrl } from "@app/core/appConstants"
import { withoutAppSideBar } from "@app/core/context/AppSideBarContext/AppSideBarContext"

/**
 * US 2886 — Beemetric routes.
 *
 * Spread into ApplicationRoutes beside RseeRoutes and BSRoutes, so the module inherits the authenticated
 * layout, the project contexts and the side bar without restating them. Its own providers and its page are
 * loaded lazily, in BeemetricRouteLayout, like every module on main.
 */
export const BeemetricRoutes = (
  // A variant's screens take the whole screen: no side bar.
  <Route
    handle={withoutAppSideBar}
    lazy={() => import("./BeemetricRouteLayout").then((module) => ({ Component: module.BeemetricRouteLayout }))}>
    <Route
      path={pagesUrl.BEEMETRIC_VARIANT_DETAILS}
      lazy={() =>
        import("@app/pages/projects/project/beemetric/BeemetricVariantDetailsPage").then((module) => ({
          Component: module.BeemetricVariantDetailsPage,
        }))
      }
    />
  </Route>
)
